<script>


    import { pedTotalscore } from './pedstores.js';
    import { pedPulsescore } from './pedstores.js';
    import { pedTempscore } from './pedstores.js';
    import { pedRRscore} from './pedstores.js';
    import { pedRespscore } from './pedstores.js';
    import { pedSatscore } from './pedstores.js';
    import { pedGutscore} from './pedstores.js';
    import { pedOtherscore} from './pedstores.js';

    export let pedPulse;
    export let pedTemp;
    export let pedRR;
    export let pedSat;
    export let pedResp;
    export let pedGut;
    export let pedOther;

    $: pedTotalscore.update(value => {
    value = pedPulse + pedTemp + pedRR + pedResp + pedSat  + pedGut + pedOther;
    return value;
    });

    </script>
    
    <style>
     h1 {
        padding: 15px; 
        text-align: center;
         margin-bottom: 0px;
     }
    
     p {
         text-align: center;
         margin: 0px;
     }
    
     h3 {
         text-align: center;
     }
     .yellow {
        color: rgb(181, 181, 15);
     }
     .orange {
        color: rgb(239, 135, 9);
    }
    
    .red {
        color: rgb(126, 5, 5);
    }
    </style>
       <div>
            {#if $pedTotalscore > 8}
                <div>
                <h1 class="red">TOTAL SCORE = {$pedTotalscore}</h1>
                <p>High Severity</p>
                    {#if $pedPulsescore == 2 || $pedTempscore == 2 || $pedRRscore == 2 || $pedSatscore == 2 }
                            {#if $pedPulsescore ==2}
                            <h3 class="orange">Pulse Alert</h3>
                            {/if}
                            {#if $pedRRscore ==2}
                            <h3 class="orange">Respiratory Rate Alert</h3>
                            {/if}
                            {#if $pedTempscore ==2}
                            <h3 class="orange">Low Temperature Alert</h3>
                            {/if}
                            {#if $pedSatscore ==2}
                            <h3 class="orange">O2 Saturation Alert</h3>
                            {/if}
                    {/if}
                </div>        
            {:else if $pedPulsescore == 2 || $pedTempscore == 2 || $pedRRscore == 2 || $pedSatscore == 2 }
                <div>
                    <h1 class="orange">TOTAL SCORE = {$pedTotalscore}</h1>
                    <p>An individual vital sign has moderate severity</p>
                        {#if $pedPulsescore ==2}
                        <h3 class="orange">Pulse Alert</h3>
                        {/if}
                        {#if $pedRRscore ==2}
                        <h3 class="orange">Respiratory Rate Alert</h3>
                        {/if}
                        {#if $pedTempscore ==3}
                        <h3 class="orange">Low Temperature Alert</h3>
                        {/if}
                        {#if $pedSatscore ==3}
                        <h3 class="orange">O2 Saturation Alert</h3>
                        {/if}
                </div>    
            {:else if $pedTotalscore > 5}
                <div>
                <h1 class="orange">TOTAL SCORE = {$pedTotalscore}</h1>
                <p>Moderate Severity
                </div>
            {:else}
                <div>
                <h1> TOTAL SCORE = {$pedTotalscore}</h1>
                <p>Low Severity</p>
                </div>
            {/if}
        
            <!-- Need to add sepsis here -->

        </div>
    
    